import { useLocalStorage } from '@rehooks/local-storage'
import { useCallback } from 'react'

import { LocalStorageKeys } from '../enums/localStorageKeys'

export const useToggleBookkeepingHero = () => {
  const [isBookkeepingHeroHidden, setIsBookkeepingHeroHidden] = useLocalStorage<boolean>(
    LocalStorageKeys.HideBookkeepingHero,
    false,
  )

  const toggleBookkeepingHero = useCallback(
    (isHidden: boolean) => {
      setIsBookkeepingHeroHidden(isHidden)

      if (window.userflow && window.userflow.setResourceCenterLauncherHidden) {
        window.userflow.setResourceCenterLauncherHidden(isHidden)
      }
    },
    [setIsBookkeepingHeroHidden],
  )

  return { isBookkeepingHeroHidden, toggleBookkeepingHero }
}
